import BaseServer from '../common/base.server.js';
import { meeting } from '@/request';

class PlaybackServer extends BaseServer {
  constructor() {
    if (typeof PlaybackServer.instance === 'object') {
      return PlaybackServer.instance;
    }
    super();
    this.state = {
      playbackList: []
    }
  }

  getPlaybackList(data = {}) {
    return meeting.getWatchRecordList(data).then(res => {
      if (res.code == 200) {
        this.state.playbackList = res.data.list
      }
    })
  }
}

export default function usePlaybackServer() {
  if (!usePlaybackServer.instance) {
    usePlaybackServer.instance = new PlaybackServer();
  }

  return usePlaybackServer.instance;
}
